// src/pages/tutor/TutorChart.js
import React from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Mon", students: 2, tasks: 1 },
  { name: "Tue", students: 3, tasks: 2 },
  { name: "Wed", students: 1, tasks: 3 },
  { name: "Thu", students: 4, tasks: 2 },
  { name: "Fri", students: 2, tasks: 1 },
];

export default function TutorChart() {
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow mt-4">
      <h3 className="text-lg font-semibold mb-4">Weekly Summary</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" stroke="#888" />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="students"
            stroke="#6366f1"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="tasks"
            stroke="#ec4899"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
